<div *ngIf="formGroup">
  <form [formGroup]="formGroup" formFocusable>
    <app-default-card
      spyTarget="taxData"
      [title]="'Einverständniserklärung'"
      [info]="'Bitte bestätigen Sie hier, dass Sie die Daten des Antrags geprüft haben.'"
      [showThisComponent]="true"
      [showChildComponent]="true">
      <app-accept-conditions
        [inputForm]="formGroup"
        [controlName]="'formConfirmation'"
        [disable]="false"
        [inputLink]=""
        [inputText]="
          'Hiermit erkläre(n) ich / wir, dass ich / wir die oben genannten Daten zur Netzanmeldung geprüft habe(n) und ich möchte die Netzanmeldung mir zuweisen.'
        "></app-accept-conditions>
    </app-default-card>
  </form>
</div>
